var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingResource } from "../../../../../balancingSelectors/selectBalancingResources";
import { IdResource } from "../../../../../constants/IdResource";
import { IdStyles } from "../../../../../less/IdStyles";
import { ReplacementLoca } from "../../../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../../../utils/i18n/utilLoca";
import { actionBeginBuyWithGoldProcess } from "../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../generic/icon/Icon";
import { actionModalOpen } from "../../../../modals/actionModal";
import { IdModal } from "../../../../modals/IdModal";
import { ButtonQuestShowMe } from "./ButtonQuestShowMe";
import { getQuestIcon } from "./getQuestIcon";
import { QuestSkipButton } from "./QuestSkipButton";
import { QuestTask } from "./QuestTask";
var _QuestTaskMakePayment = function (_a) {
    var tasks = _a.tasks, quest = _a.quest, questInfoTasks = _a.questInfoTasks, onClickShowMe = _a.onClickShowMe, onTrySkip = _a.onTrySkip;
    var task = tasks;
    var list = task.map(function (value) {
        var requiredResource = selectBalancingResource(IdResource.Gold);
        var requiredInfoTask = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentResourceAmount = requiredInfoTask.amount || 0;
        var taskCompleted = currentResourceAmount >= value.amount;
        var locaReplacements = new Map([
            [ReplacementLoca.good, requiredResource ? utilLoca.get(requiredResource.locaKey) : ""],
        ]);
        var iconName = getQuestIcon(requiredResource.name);
        var icon = React.createElement(Icon, { icon: iconName, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentResourceAmount,
            icon: icon,
            locaKey: value.locaKey,
            locaReplacements: locaReplacements,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentResourceAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + iconName }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { taskCompleted: taskCompleted, onClick: onClickShowMe, questTask: value })));
    });
    return React.createElement("div", { key: "makePayment" }, list);
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClickShowMe: function () { return actionModalOpen(IdModal.Shop); },
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskMakePayment = connect(undefined, mapDispatch)(_QuestTaskMakePayment);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/QuestTaskMakePayment.tsx
// module id = 2676
// module chunks = 3